import { Type } from 'class-transformer';
import { ContactAddressResultDto } from './contact-address-result-dto';
import { ContactInfoCustomFieldHeaderResultDto } from './contact-info-custom-field-header-result-dto';
import { ContactInfoRawDto } from './contact-info-raw-dto';
import { ContactInfoSubTypeResultDto } from './contact-info-sub-type-result-dto';
import { ContactTypeResultDto } from './contact-type-result-dto';
import { ContactOwnerRawDto } from './contact-owner-raw-dto';

export class ContactEditorResultDto {
  id: number;
  firstName: string;
  middleName: string;
  lastName: string;
  @Type(() => Date)
  birthday: Date;
  contactTypeId: number;
  isTenant: boolean;
  isLivingInProperty: boolean;
  isPublished: boolean;
  photoBase64DataString: string;
  addressTypeCode: string;
  isPrimary: boolean;
  @Type(() => ContactAddressResultDto)
  propertyAddress: ContactAddressResultDto;
  @Type(() => ContactAddressResultDto)
  mailingAddress: ContactAddressResultDto;
  @Type(() => ContactAddressResultDto)
  otherAddress: ContactAddressResultDto;
  @Type(() => ContactInfoRawDto)
  phoneData: Array<ContactInfoRawDto>;
  @Type(() => ContactInfoCustomFieldHeaderResultDto)
  phoneCustomDataFields: Array<ContactInfoCustomFieldHeaderResultDto>;
  @Type(() => ContactInfoRawDto)
  emailData: Array<ContactInfoRawDto>;
  @Type(() => ContactInfoCustomFieldHeaderResultDto)
  emailCustomDataFields: Array<ContactInfoCustomFieldHeaderResultDto>;
  @Type(() => ContactTypeResultDto)
  contactTypes: Array<ContactTypeResultDto>;
  @Type(() => ContactInfoSubTypeResultDto)
  phoneSubTypes: Array<ContactInfoSubTypeResultDto>;
  @Type(() => ContactInfoSubTypeResultDto)
  emailSubTypes: Array<ContactInfoSubTypeResultDto>;
  @Type(() => ContactOwnerRawDto)
  owners: Array<ContactOwnerRawDto>;

  // Transient
  phoneDataCopy: Array<ContactInfoRawDto>;
  emailDataCopy: Array<ContactInfoRawDto>;
}
